import { useEffect, useState } from "react";
import { SITE, waLink, WA_DEFAULT_MESSAGE, track } from "@/constants/site";

const NAV_ITEMS = [
  { label: "Soluções", href: "#solucoes" },
  { label: "Produtos", href: "#produtos" },
  { label: "Serviços", href: "#servicos" },
  { label: "Empresa", href: "#empresa" },
  { label: "Segmentos", href: "#segmentos" },
  { label: "Contato", href: "#contato" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex w-full items-center justify-between px-4 md:px-6">
        <div
          className={`flex items-center transition-all duration-300 ${
            scrolled ? "py-3" : "py-5"
          }`}
        >
          <a href="#top" className="flex items-center gap-3" aria-label="Power Motores Elétricos">
            <img
              src="https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/45d8fe31-6411-4f36-b645-a97c10d0957d_compressed_logotipo.webp"
              alt="Power Motores Elétricos"
              className="h-20 w-auto object-contain"
            />
          </a>
        </div>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Navegação principal">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href={waLink(WA_DEFAULT_MESSAGE)}
            target="_blank"
            rel="noreferrer"
            onClick={() => track("whatsapp_click")}
            className="flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-foreground-700 transition-colors hover:text-foreground-900"
          >
            <i className="ri-whatsapp-line text-lg text-[#25D366]" aria-hidden="true" />
            {SITE.whatsappDisplay}
          </a>
          <a
            href="#contato"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            Solicitar orçamento
          </a>
        </div>

        {/* Mobile controls */}
        <div className="flex items-center gap-2 lg:hidden">
          <a
            href={waLink(WA_DEFAULT_MESSAGE)}
            target="_blank"
            rel="noreferrer"
            onClick={() => track("whatsapp_click")}
            aria-label="WhatsApp"
            className="flex h-10 w-10 items-center justify-center rounded-md bg-[#25D366] text-background-50"
          >
            <i className="ri-whatsapp-line text-xl" aria-hidden="true" />
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Fechar menu" : "Abrir menu"}
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800"
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true" />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="flex flex-col px-4 py-3" aria-label="Menu mobile">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-3 text-base font-semibold text-foreground-800 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contato"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-md bg-primary-500 px-4 py-3 text-center text-base font-bold text-background-50"
            >
              Solicitar orçamento
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}